import React from 'react'

export const BrandFooter = () => {
  return (
    <div></div>
  )
}
